import React from "react";
import * as XLSX from "xlsx";
import "./ReportData.css";

const PayInReportExcel = ({ allData, fileName }) => {
  const convertToExcel = () => {
    let dateString = "";
    let date = "";
    let day = "";
    let month = "";
    let year = "";
    let hours = "";
    let minutes = "";
    let seconds = "";
    let formattedDate = "";
    let formattedTime = "";
    let finalDate = "";
    // Filter and prepare data with selective fields (Name and Age)
    const filteredData = allData?.map(
      (item) => (
        (dateString = item.createdAt),
        (date = new Date(dateString)),
        (day = date.getDate()),
        (month = date.getMonth() + 1),
        (year = date.getFullYear()),
        (hours = date.getHours()),
        (minutes = date.getMinutes()),
        (seconds = date.getSeconds()),
        (formattedDate = `${day}-${month}-${year}`),
        (formattedTime = `${hours}:${minutes}:${seconds}`),
        (finalDate = `${formattedDate}-${formattedTime}`),
        {
          Name:item.name,
          OrderId: item.orderId,
          TransactionId: item.transactionId,
          Amount: Intl.NumberFormat("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          }).format(Number(JSON.parse(item.request).amount)),
          Mode: JSON.parse(item.request).transactionMode,
          Commission:
            JSON.parse(item.resposne).RESPONSE_STATUS == "PROCESSING"
              ? ""
              : JSON.parse(item.resposne).RESPONSE_STATUS == "FAILED"
              ? ""
              : Intl.NumberFormat("en-US", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }).format(Number(item.totalComission)),
          RollingReserve:
            JSON.parse(item.resposne).RESPONSE_STATUS == "PROCESSING"
              ? ""
              : JSON.parse(item.resposne).RESPONSE_STATUS == "FAILED"
              ? ""
              : Intl.NumberFormat("en-US", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }).format(Number(item.rollingReserve)),
          // ClosingBalance:
          //   JSON.parse(item.resposne).RESPONSE_STATUS == "PROCESSING"
          //     ? ""
          //     : JSON.parse(item.resposne).RESPONSE_STATUS == "FAILED"
          //     ? ""
          //     : item.closingBalance,
          Status: JSON.parse(item.resposne).RESPONSE_STATUS,
          Date: finalDate,
          CustomerName: JSON.parse(item.request).customerName,
          CustomerMobile: JSON.parse(item.request).customerMobile,
          CustomerEmail: JSON.parse(item.request).customerEmail,
          CustomerVPA: JSON.parse(item.request).vpa,
          RefId: item.referenceId,
         
        }
      )
    );

    // console.log("finaAtransaction1212121212", filteredData);

    // Define headers corresponding to selective fields
    const headers = [
      "Name",
      "OrderId",
      "TransactionId",
      "Amount",
      "Mode",
      "Commission",
      "RollingReserve",
      // "ClosingBalance",
      "Status",
      "Date",
      "CustomerName",
      "CustomerMobile",
      "CustomerEmail",
      "CustomerVPA",
      "RefId",

    ];

    const worksheet = XLSX.utils.json_to_sheet(filteredData, {
      header: headers,
    });
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    XLSX.writeFile(workbook, `${fileName}.xlsx`);
  };

  return (
    <div>
      <button onClick={convertToExcel} className="exp-but">
        Download
      </button>
    </div>
  );
};

export default PayInReportExcel;